'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { useContext, createContext } from 'react';

/**
 * Создает контекст и хук для получения его данных.
 * @param Изначальное значение контекста.
 * @returns Кортеж `[Provider, useProvider]`
 */ function createBareContext(value) {
    var Context = /*#__PURE__*/ createContext(value || null);
    var useUnsafeContext = function() {
        return useContext(Context);
    };
    var Provider = function(param) {
        var children = param.children, _$value = param.value;
        return /*#__PURE__*/ jsx(Context.Provider, {
            value: _$value,
            children: children
        });
    };
    return [
        Provider,
        useUnsafeContext
    ];
}

export { createBareContext };
